import areEquivalentUserPromptEvents from '@/lib/activityEvents/areEquivalentUserPromptEvents.js';
import getPieveActivityEventSeq from '@/lib/activityEvents/getPieveActivityEventSeq.js';
import isPendingUserBubbleEvent from '@/lib/activityEvents/isPendingUserBubbleEvent.js';
import preserveExistingInteractionResponsePresentation from '@/lib/activityEvents/preserveExistingInteractionResponsePresentation.js';
import shouldPreserveExistingEventLines from '@/lib/activityEvents/shouldPreserveExistingEventLines.js';
import shouldPreserveExistingInteractionResponseSummary from '@/lib/activityEvents/shouldPreserveExistingInteractionResponseSummary.js';
import isDeepEqual from '@/lib/isDeepEqual.js';

const mergeHydratedActivityEvents = ({ existingEvents, incomingEvents, preserveProvisionalEvents = true }) => {
  const nextEvents = [...(Array.isArray(incomingEvents) ? incomingEvents : [])];

  const shouldSkipPendingUserCarryover = (existingEvent) => {
    if (!isPendingUserBubbleEvent(existingEvent)) {
      return false;
    }

    for (const incomingEvent of nextEvents) {
      if (isPendingUserBubbleEvent(incomingEvent)) {
        continue;
      }

      if (
        areEquivalentUserPromptEvents({
          existingEvent,
          incomingEvent
        })
      ) {
        return true;
      }
    }

    return false;
  };

  for (const event of existingEvents || []) {
    if (!preserveProvisionalEvents && event?.assistantTextFinal !== true) {
      continue;
    }

    const eventSeq = getPieveActivityEventSeq(event);
    const indexById = event?.id ? nextEvents.findIndex((candidate) => candidate?.id === event.id) : -1;
    const indexBySeq = indexById >= 0 || eventSeq === null ? -1 : nextEvents.findIndex((candidate) => getPieveActivityEventSeq(candidate) === eventSeq);
    const targetIndex = indexById >= 0 ? indexById : indexBySeq;

    if (targetIndex < 0) {
      if (!preserveProvisionalEvents || shouldSkipPendingUserCarryover(event)) {
        continue;
      }

      nextEvents.push(event);
      continue;
    }

    const incomingEvent = nextEvents[targetIndex] || {};
    const mergedEventWithStableLines = shouldPreserveExistingEventLines({
      existingEvent: event,
      incomingEvent
    })
      ? {
          ...incomingEvent,
          lines: event.lines,
          ...(event.assistantTextFinal === true ? { assistantTextFinal: true } : {})
        }
      : incomingEvent;
    const mergedEvent = shouldPreserveExistingInteractionResponseSummary({
      existingEvent: event,
      incomingEvent: mergedEventWithStableLines
    })
      ? preserveExistingInteractionResponsePresentation({
          existingEvent: event,
          incomingEvent: mergedEventWithStableLines
        })
      : mergedEventWithStableLines;

    if (!isDeepEqual(incomingEvent, mergedEvent)) {
      nextEvents[targetIndex] = mergedEvent;
    }
  }

  return nextEvents;
};

export default mergeHydratedActivityEvents;
